import styled from 'styled-components';

export const StatusBarWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  background: rgb(255, 255, 255);
  width: 100%;
  left: 0px;
  padding: 1.5rem 1rem;
  border-top: 5px solid rgb(75, 40, 109);
  z-index: 1;
`;
export const BoxWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
`;
export const DueMonthlyWrapper = styled.div`
  display: inline-block;
  padding: 0 20px 0 0;
  height: 100px;
  vertical-align: top;
`;
export const IntegralPart = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #2a2c2e;
`;
export const LabelDueMonthly = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
  display: block;
`;
export const PricingBlockMain = styled.div`
  display: flex;
  float: none;
`;
export const BeforeTaxesLabel = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
`;
export const DueNowWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px;
  height: 100px;
  border-left: solid 1px #acacac;
  vertical-align: top;
`;
